import React from 'react';
import md5 from 'md5';

interface FileLinkProps {
  file: GQL.IFile;
}

const FileLink = ({ file }: FileLinkProps) => {
  return (
    <a
      href={`${process.env.REACT_APP_FILE_DOWNLOAD}?id=${file.id}&hash=${md5(`bonato${file.id}`)}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      {file.filename}
    </a>
  );
};

export default FileLink;
